import { TFunction, TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

export function useTranslationByKey(tSectionKey: string): TFunction {
  const { t } = useTranslation();

  const tByKey = (tKey: string, options?: TOptions<Record<string, string>> | string): string => {
    const key = `${tSectionKey}.${tKey}`;
    const finalOptions = typeof options === 'string' ? { defaultValue: options } : options;
    return t(key, finalOptions);
  };

  return tByKey as TFunction;
}
